import React from "react";
import { Loader2 } from "lucide-react";

/**
 * Componente de loading para Suspense boundaries
 */
export function SuspenseLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-teal-600 animate-spin mx-auto mb-4" />
        <p className="text-slate-600 font-medium">Carregando...</p>
      </div>
    </div>
  );
}

export default SuspenseLoader;
